<template>
  <a-modal
    class="client-modal-wrapper"
    width="900px"
    :mask-closable="false"
    :visible="visible"
    :footer="null"
    :title="title"
    @cancel="$emit('onCancel')"
  >
    <a-form layout="horizontal" :form="form" style="margin-bottom: 90px">
		 <a-row :gutter="24">
			  <a-col :span="12">
				  <a-form-item
				    label="考试等级"
				    :colon="false"
				    :label-col="{ span: 5 }"
				    :wrapper-col="{ span: 17 }"
				  >
				    <!-- <a-select
				      v-decorator="[
				        'questions_level',
				        {
				          rules: [{ required: true, message: '请选择考试等级' }],
				          initialValue: 1,
				        },
				      ]"
				      placeholder="请选择考试等级"
				      @change="changeSelect2"
				    >
				      <a-select-option :value="1"> 初级 </a-select-option>
				      <a-select-option :value="2"> 中级 </a-select-option>
				      <a-select-option :value="3"> 高级 </a-select-option>
				      <a-select-option :value="4"> 技师 </a-select-option>
				      <a-select-option :value="5"> 高级技师 </a-select-option>
				    </a-select> -->
					 
					<a-cascader
					v-decorator="[
					  'questions_level',
					  {
					    rules: [{ required: true, message: '请选择考试等级' }],
					    initialValue: [],
					  },
					]"
					    :options="optionsData"
					    @change="changeSelect2"
						:fieldNames="{ label: 'name', value: 'id', children: 'children' }"
					    placeholder="请选择考试等级"
					  />
				  </a-form-item>
			  </a-col>
			  <a-col :span="12">
			  				 <a-form-item
			  				   label="题目难度"
			  				   :colon="false"
			  				   :label-col="{ span: 5 }"
			  				   :wrapper-col="{ span: 17 }"
			  				 >
			  				   <a-select
			  					 v-decorator="[
			  					   'difficulty',
			  					   {
			  						 rules: [{ required: true, message: '请选择题目难度' }],
			  						 initialValue: 1,
			  					   },
			  					 ]"
			  					 placeholder="请选择题目类型"
			  					 @change="changeSelect1"
			  				   >
			  					 <a-select-option :value="1"> 容易 </a-select-option>
			  					 <a-select-option :value="2"> 中等 </a-select-option>
			  					 <a-select-option :value="3"> 困难 </a-select-option>
			  				   </a-select>
			  				 </a-form-item>
			  </a-col>
			  <a-col :span="12">
					   <a-form-item
						 label="一致性"
						 :colon="false"
						 :label-col="{ span: 5 }"
						 :wrapper-col="{ span: 17 }"
					   >
						 <a-input
						   v-decorator="[
							 'uniformity',
							 {
							   rules: [
								 {
								   required: true,
								   message: '请输入一致性描述',
								 },
							   ],
							 },
						   ]"
						   placeholder="请输入一致性描述"
						 />
					   </a-form-item>
			  </a-col>
			 
			 
			   
			   <a-col :span="12">
				 <a-form-item
				   label="分数"
				   :colon="false"
				   :label-col="{ span: 5 }"
				   :wrapper-col="{ span: 17 }"
				 >
				   <a-input-number
					 v-decorator="[
					   'score',
					   {
						 rules: [
						   {
							 required: true,
							 message: '请输入本题分数',
						   },
						 ],
					   },
					 ]"
					 :min="1"
					 style="width: 100%"
					 placeholder="请输入本题分数"
				   />
				 </a-form-item>
			   </a-col>
			   <a-col :span="12">
				  <a-form-item
				    label="解析"
				    :colon="false"
				    :label-col="{ span: 5 }"
				    :wrapper-col="{ span: 17 }"
				  >
				    <a-input v-decorator="[
					   'analysis',
					   {
						 rules: [
						   {
							 required: true,
							 message: '请输入解析',
						   },
						 ],
					   },
					 ]" placeholder="请输入解析" type="textarea" />
				  </a-form-item>
			   </a-col>
			   <a-col :span="12">
					<a-form-item
					  label="出处"
					  :colon="false"
					  :label-col="{ span: 5 }"
					  :wrapper-col="{ span: 17 }"
					>
					  <a-input v-decorator="[
					   'provenance',
					   {
						 rules: [
						   {
							 required: true,
							 message: '请输入出处',
						   },
						 ],
					   },
					 ]"
					   placeholder="请输入本题出处" type="textarea" />
					</a-form-item>
			   </a-col>	  
			   </a-col>
			   
			   <a-col :span="12"  v-for="i in 6" :key="i">
					   <a-form-item
						  :label="`知识点${i}级`"
						 :colon="false"
						 :label-col="{ span: 5 }"
						 :wrapper-col="{ span: 17 }"
						>
						 <a-input
						   v-decorator="[
							`knowledge${i}`,
							 {
							   rules: [
								 {
								   required: true,
								   message: '请输入知识点'+i+'级',
								 },
							   ],
							 },
						   ]"
						   :placeholder="`请输入知识点${i}级，没有请填：无`"
						 />
					   </a-form-item>
			   				
			   </a-col>
			   <a-col :span="12">
			   				   <a-form-item
			   					 label="正确答案"
			   					 :colon="false"
			   					 :label-col="{ span: 5 }"
			   					 :wrapper-col="{ span: 17 }"
			   					>
			   					 <a-input
			   					   v-decorator="[
			   						 'answer',
			   						 {
			   						   rules: [
			   							 {
			   							   required: true,
			   							   message: '请输入正确答案',
			   							 },
			   						   ],
			   						 },
			   					   ]"
			   					   placeholder="请输入正确答案，多选题答案格式：ABD"
                     style="text-transform:uppercase"
			   					 />
			   				   </a-form-item>
			   				
			   </a-col>
		 </a-row>
		
		
     
      

		  <a-form-item
			label="题目类型"
			:colon="false"
			:label-col="{ span: 5 }"
			:wrapper-col="{ span: 17 }"
		  >
			<a-select
			  v-decorator="[
				'type',
				{
				  rules: [{ required: true, message: '请选择题目类型' }],
				  initialValue: '1',
				},
			  ]"
			  placeholder="请选择题目类型"
			  :disabled="selectIsDisabled"
			  @change="changeSelect"
			>
			 <!-- <a-select-option
				v-for="(item, index) in questionType"
				:key="item.key"
				:value="item.key"
				v-if="index"
			  >
				{{ item.name }}
			  </a-select-option> -->
				  
				  <a-select-option value="1"> 单选题 </a-select-option>
				  <a-select-option value="2"> 多选题 </a-select-option>
				  <a-select-option value="3"> 判断题 </a-select-option>
		  
			</a-select>
		  </a-form-item>

      <a-form-item
        label="题干"
        :colon="false"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 17 }"
      >
        <a-textarea
          v-decorator="[
            'question',
            {
              rules: [
                {
                  required: true,
                  message: '请输入题干',
                },
              ],
            },
          ]"
          placeholder="请输入题干"
        />
      </a-form-item>
      <template>
		 
        <a-form-item
          v-for="(item, index) in questionData.options"
          :key="item.key"
          :colon="false"
          :label="getlabel(index)"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 17 }"
        >
          <a-input
            v-decorator="[
              `${item.key}.value`,
              {
                rules: [
                  {
                    required: true,
                    message: '请输入问题选项',
                  },
                ],
              },
            ]"
            placeholder="请输入问题选项"
            style="width: 92%; margin-right: 8px"
          />
          <a-icon
            v-if="questionData.options.length > 1"
            class="question-delete-button"
            type="minus-circle-o"
            :disabled="questionData.options.length === 1"
            @click="() => remove(index)"
          />
        </a-form-item>
      </template>
      <a-form-item
       
        :colon="false"
        :wrapper-col="{ span: 17, offset: 5 }"
      >
        <a-button type="dashed" style="width: 60%" @click="add">
          <a-icon type="plus" /> 增加项
        </a-button>
      </a-form-item>
    </a-form>
    <slot />
  </a-modal>
</template>
<script>
const uuidv1 = require("uuid/v1");
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
	optionsData: {
      type: Array,
	  default: [],
    },
    title: {
      type: String,
    },
    selectIsDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      productData: [],
      questionType: [
        { key: "1", name: "单选题" },
        { key: "2", name: "多选题" },
        { key: "3", name: "判断题" },
      ],
      type: "1",
      questions_level: "",
      difficulty: "",
      questionData: {
        options: [{ key: uuidv1(), value: "" }],
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  mounted() {
    // 获取产品
    this.getProduct();
  },
  methods: {
	  getlabel(index){
		  if(index===0){
			  return '答案A'
		  }else if(index===1){
			  return '答案B'
		  }else if(index===2){
			  return '答案C'
		  }else if(index===3){
			  return '答案D'
		  }else if(index===4){
			  return '答案E'
		  }
	  },
    // 获取合作企业
    async getProduct() {
      let result = await this.$http.post("/product/getList");
      if (result.data.status === 1) {
        this.productData = result.data.data.data_list;
      }
    },
    initData() {
      this.questionData = { options: [{ key: uuidv1(), value: "" }] };
      this.type = "1";
    },
    updateData(options, type) {
      this.questionData = { options: JSON.parse(JSON.stringify(options)) };
      this.type = type;
    },
    remove(key) {
      this.questionData.options = this.questionData.options.filter(
        (item, index) => index !== key
      );
      console.log(
        "remove -> this.questionData.options",
        this.questionData.options
      );
    },
    add() {
      if(this.questionData.options.length===5){
		  this.$message.error('只能添加5条答案哦');
		  return
	  }
      this.questionData.options.push({ key: uuidv1(), value: "" });
      this.questionData = JSON.parse(JSON.stringify(this.questionData));
      console.log("TCL: add -> this.questionData", this.questionData);
    },
    // 下拉框选择
    changeSelect1(key) {
      this.difficulty = key;
      // this.questionData = {
      //   difficulty: key,
      //   type: this.type,
      //   questions_level: this.questions_level,
      //   options: [{ key: uuidv1(), value: "" }],
      // };
    },
    changeSelect2(key) {
      this.questions_level = key;
      // this.questionData = {
      //   questions_level: key,
      //   type: this.type,
      //   difficulty: this.difficulty,
      //   options: [{ key: uuidv1(), value: "" }],
      // };
    },
    changeSelect(key) {
      this.type = key;
      this.questionData = {
        type: key,
        difficulty: this.difficulty,
        questions_level: this.questions_level,
        question: "",
        options: [{ key: uuidv1(), value: "" }],
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.question-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}
.question-delete-button:hover {
  color: #777;
}
.question-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
